/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './farmer-devices.scss';

/* eslint-disable import/no-unresolved, import/default */

import farmerDevicesTemplate from './farmer-devices.tpl.html';
import farmerAddDeviceDialogTemplate from './farmer-add-device.tpl.html';
import farmerDevicesSelectTemplate from './farmer-devices-select.tpl.html';// eslint-disable-line
import cropBackground from './../../img/crop.jpg';// eslint-disable-line
import sensorsSpearImg from './../../img/cellular-spear.png';
import cProImg from './../../img/c-pro.jpg';
import superProImg from './../../img/Superpro.jpg';
import farmProImg from './../../img/Farmpro.jpg';
import superPointImg from './../../img/Superpoint.jpg';
import farmPointImg from './../../img/Farmpoint.jpg';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.farmerDevices', [])
    .directive('farmerDevices', FarmerDevices)
    .name;

/*@ngInject*/
function FarmerDevices () {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: FarmerDevicesController,
        controllerAs: 'vm',
        templateUrl: farmerDevicesTemplate
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function FarmerDevicesController($scope, $mdDialog, $document, agTypes, userService) {

    let vm = this;
    vm.agTypes = agTypes;

    vm.currentWidgetType = currentWidgetType;
    vm.selectDevice = selectDevice;
    vm.isCustomer = isCustomer;
    vm.openSelectDeviceDialog = openSelectDeviceDialog;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';

    $scope.$watch('vm.ctx', () => {
        if (vm.ctx && vm.showData) {
            // vm.ctx.widgetConfig.widgetStyle["background"] = "url(" + cropBackground + ") center no-repeat";
            // vm.ctx.widgetConfig.widgetStyle["background-size"] = "cover";
            vm.ctx.assetBrowserWidgetTypes = agTypes.assetBrowserWidgetType;
            vm.ctx.agTypes = agTypes;
            vm.ctx.currentWidgetType = agTypes.assetBrowserWidgetType.dashboard;
            // vm.ctx.widgetTitleTemplate = farmerDevicesSelectTemplate;
        }
    });

    $scope.$on('farmerDevicesViewChanged', (event, devicesView) => {
        vm.ctx.currentWidgetType = devicesView
    });

    function currentWidgetType() {
        if (vm.ctx) {
            return vm.ctx.currentWidgetType;
        } else {
            return null;
        }
    }

    function selectDevice(device) {
        let params = angular.copy(vm.ctx.stateController.getStateParams());
        if (!params) {
            params = {
                assetBrowserWidgetType: vm.ctx.currentWidgetType
            };
        }
        params.entityId = device.id;
        params.entityName = device.name;
        let currentStateId = vm.ctx.stateController.getStateId();
        vm.ctx.stateController.updateState(currentStateId, params, true);
    }

    function isCustomer() {
        if (userService.getAuthority() === 'CUSTOMER_USER') {
            return true;
        }
    }

    function openSelectDeviceDialog($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: OpenAddDeviceDialogController,
            controllerAs: 'vm',
            templateUrl: farmerAddDeviceDialogTemplate,
            parent: angular.element($document[0].body),
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        }).then(
            () => {
                $scope.$broadcast("reloadFarmerDevices");
            }
        );
    }
}

/*@ngInject*/
function OpenAddDeviceDialogController($mdDialog, toast, utils, agUtils, agTypes, deviceService, agDeviceService) {

    var vm = this;
    vm.agTypes = agTypes;

    const SELECT_STEP = "Select";
    const ADD_STEP = "Add";

    vm.addDeviceStep = SELECT_STEP;
    vm.currentDeviceType = null;
    vm.newDevice = {};

    vm.cancel = cancel;
    vm.back = back;
    vm.selectDeviceType = selectDeviceType;
    vm.getDeviceImg = getDeviceImg;
    vm.saveDevice = saveDevice;

    function selectDeviceType(deviceType) {
        vm.currentDeviceType = deviceType;
        vm.addDeviceStep = ADD_STEP;
        vm.newDevice = {};
    }

    function getDeviceImg(deviceType) {
        switch (deviceType) {
            case agTypes.farmerDeviceTypes.cellularSensorSpear.value:
                return sensorsSpearImg;
            case agTypes.farmerDeviceTypes.cPro.value:
                return cProImg;
            case agTypes.farmerDeviceTypes.superPro.value:
                return superProImg;
            case agTypes.farmerDeviceTypes.farmPro.value:
                return farmProImg;
            case agTypes.farmerDeviceTypes.superPoint.value:
                return superPointImg;
            case agTypes.farmerDeviceTypes.farmPoint.value:
                return farmPointImg;
        }
        return null;
    }

    function saveDevice() {
        vm.loading = true;
        if (agUtils.ifMoistureDevice(vm.currentDeviceType)) {
            vm.newDevice.name = utils.guid();
            vm.newDevice.type = vm.currentDeviceType;
            deviceService.saveDevice(vm.newDevice).then(
                () => {
                    vm.loading = false;
                    $mdDialog.hide();
                },
                () => {
                    vm.loading = false;
                }
            );
        } else if (vm.currentDeviceType === agTypes.farmerDeviceTypes.cellularSensorSpear.value) {
            agDeviceService.claimDevice(vm.newDevice.name, vm.newDevice.secretKey, {ignoreErrors: true}).then(
                (data) => {
                    data.device.label = vm.newDevice.label;
                    deviceService.saveDevice(data.device).then(
                        () => {
                            vm.loading = false;
                            $mdDialog.hide();
                        },
                        () => {
                            vm.loading = false;
                        }
                    );
                },
                () => {
                    toast.showError('Error! Please check "Serial number" and "Secret key"', angular.element(".select-farmer-device-dialog"), 'bottom left');
                    vm.loading = false;
                }
            );
        }
    }

    function back() {
        vm.addDeviceStep = SELECT_STEP;
    }

    function cancel() {
        $mdDialog.cancel();
    }
}